export const designTokens = {
    color: {
        background: '#F7F2EA',
        backgroundSoft: '#F2EADF',
        canvas: '#FFFDF8',
        surface: '#FFFDF8',
        surfaceWarm: '#FFF7ED',
        surfaceMuted: '#F2EADF',
        primary: '#C75F3E',
        primaryDark: '#A94B30',
        primarySoft: '#F0D8CB',
        text: '#1F1F1D',
        textStrong: '#121210',
        muted: '#5F625D',
        mutedCool: '#8B8A83',
        border: '#E3DED4',
        divider: '#ECE5DA',
        green: '#74866B',
        greenDark: '#566B50',
        greenSoft: '#E7ECE1',
        gold: '#C9953E',
        goldSoft: '#F3E9D8',
        danger: '#B85A45',
        warning: '#C9953E',
        success: '#6F8A63',
        purpleSoft: '#DCD4EA',
        shadowWarm: 'rgba(64, 45, 25, 0.08)',
        overlay: 'rgba(31, 31, 29, 0.44)',
    },
    space: {
        '2xs': 4,
        xs: 4,
        sm: 8,
        md: 12,
        lg: 16,
        card: 20,
        xl: 24,
        lg2: 28,
        xxl: 32,
        xxxl: 40,
        display: 48,
        pageX: 24,
        pageBottom: 118,
    },
    radius: {
        xs: 8,
        sm: 12,
        md: 18,
        lg: 20,
        xl: 28,
        card: 24,
        hero: 32,
        sheet: 32,
        pill: 999,
    },
    typography: {
        fontFamily: {
            display: 'Fraunces, Georgia, "Times New Roman", serif',
            body: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            chinese: '"Noto Serif SC", "Songti SC", "STSong", serif',
        },
        fontSize: {
            xs: 13,
            sm: 14,
            md: 16,
            lg: 20,
            xl: 24,
            title: 44,
            display: 52,
            h1: 44,
            h2: 30,
            h3: 24,
            cardTitle: 20,
            body: 16,
            meta: 13,
            button: 16,
        },
        lineHeight: {
            display: 0.95,
            h1: 0.98,
            h2: 1.1,
            h3: 1.15,
            cardTitle: 1.2,
            body: 1.45,
            meta: 1.3,
            button: 1,
            tight: 1.08,
            normal: 1.45,
            relaxed: 1.62,
        },
        weight: {
            regular: 400,
            medium: 600,
            bold: 700,
        },
    },
    shadow: {
        card: '0 14px 36px rgba(64, 45, 25, 0.08)',
        floating: '0 18px 42px rgba(64, 45, 25, 0.14)',
        soft: '0 6px 18px rgba(64, 45, 25, 0.06)',
        button: '0 12px 22px rgba(199, 95, 62, 0.22)',
    },
    layout: {
        mobileMinWidth: 320,
        mobileMaxWidth: 480,
        mobileReferenceWidth: 430,
        contentMaxWidth: 720,
        bottomNavHeight: 78,
        askBarHeight: 56,
    },
};
export const colors = {
    background: designTokens.color.background,
    backgroundSoft: designTokens.color.backgroundSoft,
    surface: designTokens.color.surface,
    surfaceWarm: designTokens.color.surfaceWarm,
    primary: designTokens.color.primary,
    primaryDark: designTokens.color.primaryDark,
    text: designTokens.color.text,
    muted: designTokens.color.muted,
    border: designTokens.color.border,
    divider: designTokens.color.divider,
    green: designTokens.color.green,
    greenDark: designTokens.color.greenDark,
    greenSoft: designTokens.color.greenSoft,
    sage: designTokens.color.green,
    sageSoft: designTokens.color.greenSoft,
    sand: designTokens.color.gold,
    sandSoft: designTokens.color.goldSoft,
    warning: designTokens.color.warning,
    danger: designTokens.color.danger,
    success: designTokens.color.success,
    terracottaSoft: designTokens.color.primarySoft,
    purpleSoft: designTokens.color.purpleSoft,
    elevation: designTokens.color.shadowWarm,
};
export const spacing = {
    xs: designTokens.space.xs,
    sm: designTokens.space.sm,
    md: designTokens.space.md,
    lg: designTokens.space.lg,
    card: designTokens.space.card,
    xl: designTokens.space.xl,
    lg2: designTokens.space.lg2,
    xxl: designTokens.space.xxl,
    xxxl: designTokens.space.xxxl,
    pageX: designTokens.space.pageX,
    section: designTokens.space.xxl,
};
export const radius = {
    sm: designTokens.radius.sm,
    md: designTokens.radius.md,
    lg: designTokens.radius.lg,
    xl: designTokens.radius.xl,
    card: designTokens.radius.card,
    hero: designTokens.radius.hero,
    pill: designTokens.radius.pill,
};
export const typography = {
    display: designTokens.typography.fontFamily.display,
    body: designTokens.typography.fontFamily.body,
    chinese: designTokens.typography.fontFamily.chinese,
    sizes: designTokens.typography.fontSize,
    lineHeights: designTokens.typography.lineHeight,
};
export const tokenVariables = [
    { cssName: '--mira-bg', wxssName: '--mira-bg', value: designTokens.color.background, path: 'color.background' },
    { cssName: '--mira-bg-soft', wxssName: '--mira-bg-soft', value: designTokens.color.backgroundSoft, path: 'color.backgroundSoft' },
    { cssName: '--mira-canvas', wxssName: '--mira-canvas', value: designTokens.color.canvas, path: 'color.canvas' },
    { cssName: '--mira-surface', wxssName: '--mira-surface', value: designTokens.color.surface, path: 'color.surface' },
    { cssName: '--mira-surface-warm', wxssName: '--mira-surface-warm', value: designTokens.color.surfaceWarm, path: 'color.surfaceWarm' },
    { cssName: '--mira-surface-muted', wxssName: '--mira-surface-muted', value: designTokens.color.surfaceMuted, path: 'color.surfaceMuted' },
    { cssName: '--mira-primary', wxssName: '--mira-primary', value: designTokens.color.primary, path: 'color.primary' },
    { cssName: '--mira-primary-dark', wxssName: '--mira-primary-dark', value: designTokens.color.primaryDark, path: 'color.primaryDark' },
    { cssName: '--mira-primary-soft', wxssName: '--mira-primary-soft', value: designTokens.color.primarySoft, path: 'color.primarySoft' },
    { cssName: '--mira-text', wxssName: '--mira-text', value: designTokens.color.text, path: 'color.text' },
    { cssName: '--mira-text-strong', wxssName: '--mira-text-strong', value: designTokens.color.textStrong, path: 'color.textStrong' },
    { cssName: '--mira-muted', wxssName: '--mira-muted', value: designTokens.color.muted, path: 'color.muted' },
    { cssName: '--mira-muted-cool', wxssName: '--mira-muted-cool', value: designTokens.color.mutedCool, path: 'color.mutedCool' },
    { cssName: '--mira-border', wxssName: '--mira-border', value: designTokens.color.border, path: 'color.border' },
    { cssName: '--mira-green', wxssName: '--mira-green', value: designTokens.color.green, path: 'color.green' },
    { cssName: '--mira-green-dark', wxssName: '--mira-green-dark', value: designTokens.color.greenDark, path: 'color.greenDark' },
    { cssName: '--mira-green-soft', wxssName: '--mira-green-soft', value: designTokens.color.greenSoft, path: 'color.greenSoft' },
    { cssName: '--mira-gold', wxssName: '--mira-gold', value: designTokens.color.gold, path: 'color.gold' },
    { cssName: '--mira-gold-soft', wxssName: '--mira-gold-soft', value: designTokens.color.goldSoft, path: 'color.goldSoft' },
    { cssName: '--mira-divider', wxssName: '--mira-divider', value: designTokens.color.divider, path: 'color.divider' },
    { cssName: '--mira-warning', wxssName: '--mira-warning', value: designTokens.color.warning, path: 'color.warning' },
    { cssName: '--mira-danger', wxssName: '--mira-danger', value: designTokens.color.danger, path: 'color.danger' },
    { cssName: '--mira-success', wxssName: '--mira-success', value: designTokens.color.success, path: 'color.success' },
    { cssName: '--mira-purple-soft', wxssName: '--mira-purple-soft', value: designTokens.color.purpleSoft, path: 'color.purpleSoft' },
    { cssName: '--mira-overlay', wxssName: '--mira-overlay', value: designTokens.color.overlay, path: 'color.overlay' },
    { cssName: '--mira-space-xs', wxssName: '--mira-space-xs', value: designTokens.space.xs, unit: 'px', path: 'space.xs' },
    { cssName: '--mira-space-sm', wxssName: '--mira-space-sm', value: designTokens.space.sm, unit: 'px', path: 'space.sm' },
    { cssName: '--mira-space-md', wxssName: '--mira-space-md', value: designTokens.space.md, unit: 'px', path: 'space.md' },
    { cssName: '--mira-space-lg', wxssName: '--mira-space-lg', value: designTokens.space.lg, unit: 'px', path: 'space.lg' },
    { cssName: '--mira-space-card', wxssName: '--mira-space-card', value: designTokens.space.card, unit: 'px', path: 'space.card' },
    { cssName: '--mira-space-xl', wxssName: '--mira-space-xl', value: designTokens.space.xl, unit: 'px', path: 'space.xl' },
    { cssName: '--mira-space-lg2', wxssName: '--mira-space-lg2', value: designTokens.space.lg2, unit: 'px', path: 'space.lg2' },
    { cssName: '--mira-space-xxl', wxssName: '--mira-space-xxl', value: designTokens.space.xxl, unit: 'px', path: 'space.xxl' },
    { cssName: '--mira-space-xxxl', wxssName: '--mira-space-xxxl', value: designTokens.space.xxxl, unit: 'px', path: 'space.xxxl' },
    { cssName: '--mira-page-x', wxssName: '--mira-page-x', value: designTokens.space.pageX, unit: 'px', path: 'space.pageX' },
    { cssName: '--mira-page-bottom', wxssName: '--mira-page-bottom', value: designTokens.space.pageBottom, unit: 'px', path: 'space.pageBottom' },
    { cssName: '--mira-radius-sm', wxssName: '--mira-radius-sm', value: designTokens.radius.sm, unit: 'px', path: 'radius.sm' },
    { cssName: '--mira-radius-md', wxssName: '--mira-radius-md', value: designTokens.radius.md, unit: 'px', path: 'radius.md' },
    { cssName: '--mira-radius-lg', wxssName: '--mira-radius-lg', value: designTokens.radius.lg, unit: 'px', path: 'radius.lg' },
    { cssName: '--mira-radius-xl', wxssName: '--mira-radius-xl', value: designTokens.radius.xl, unit: 'px', path: 'radius.xl' },
    { cssName: '--mira-radius-card', wxssName: '--mira-radius-card', value: designTokens.radius.card, unit: 'px', path: 'radius.card' },
    { cssName: '--mira-radius-hero', wxssName: '--mira-radius-hero', value: designTokens.radius.hero, unit: 'px', path: 'radius.hero' },
    { cssName: '--mira-radius-pill', wxssName: '--mira-radius-pill', value: designTokens.radius.pill, unit: 'px', path: 'radius.pill' },
    { cssName: '--mira-font-display', wxssName: '--mira-font-display', value: designTokens.typography.fontFamily.display, path: 'typography.fontFamily.display' },
    { cssName: '--mira-font-body', wxssName: '--mira-font-body', value: designTokens.typography.fontFamily.body, path: 'typography.fontFamily.body' },
    { cssName: '--mira-font-chinese', wxssName: '--mira-font-chinese', value: designTokens.typography.fontFamily.chinese, path: 'typography.fontFamily.chinese' },
    { cssName: '--mira-type-display', wxssName: '--mira-type-display', value: designTokens.typography.fontSize.display, unit: 'px', path: 'typography.fontSize.display' },
    { cssName: '--mira-type-h1', wxssName: '--mira-type-h1', value: designTokens.typography.fontSize.h1, unit: 'px', path: 'typography.fontSize.h1' },
    { cssName: '--mira-type-h2', wxssName: '--mira-type-h2', value: designTokens.typography.fontSize.h2, unit: 'px', path: 'typography.fontSize.h2' },
    { cssName: '--mira-type-h3', wxssName: '--mira-type-h3', value: designTokens.typography.fontSize.h3, unit: 'px', path: 'typography.fontSize.h3' },
    { cssName: '--mira-type-card-title', wxssName: '--mira-type-card-title', value: designTokens.typography.fontSize.cardTitle, unit: 'px', path: 'typography.fontSize.cardTitle' },
    { cssName: '--mira-type-body', wxssName: '--mira-type-body', value: designTokens.typography.fontSize.body, unit: 'px', path: 'typography.fontSize.body' },
    { cssName: '--mira-type-meta', wxssName: '--mira-type-meta', value: designTokens.typography.fontSize.meta, unit: 'px', path: 'typography.fontSize.meta' },
    { cssName: '--mira-type-button', wxssName: '--mira-type-button', value: designTokens.typography.fontSize.button, unit: 'px', path: 'typography.fontSize.button' },
    { cssName: '--mira-line-display', wxssName: '--mira-line-display', value: designTokens.typography.lineHeight.display, path: 'typography.lineHeight.display' },
    { cssName: '--mira-line-h1', wxssName: '--mira-line-h1', value: designTokens.typography.lineHeight.h1, path: 'typography.lineHeight.h1' },
    { cssName: '--mira-line-h2', wxssName: '--mira-line-h2', value: designTokens.typography.lineHeight.h2, path: 'typography.lineHeight.h2' },
    { cssName: '--mira-line-h3', wxssName: '--mira-line-h3', value: designTokens.typography.lineHeight.h3, path: 'typography.lineHeight.h3' },
    { cssName: '--mira-line-card-title', wxssName: '--mira-line-card-title', value: designTokens.typography.lineHeight.cardTitle, path: 'typography.lineHeight.cardTitle' },
    { cssName: '--mira-line-body', wxssName: '--mira-line-body', value: designTokens.typography.lineHeight.body, path: 'typography.lineHeight.body' },
    { cssName: '--mira-line-meta', wxssName: '--mira-line-meta', value: designTokens.typography.lineHeight.meta, path: 'typography.lineHeight.meta' },
    { cssName: '--mira-line-button', wxssName: '--mira-line-button', value: designTokens.typography.lineHeight.button, path: 'typography.lineHeight.button' },
    { cssName: '--mira-shadow-card', wxssName: '--mira-shadow-card', value: designTokens.shadow.card, path: 'shadow.card' },
    { cssName: '--mira-shadow-soft', wxssName: '--mira-shadow-soft', value: designTokens.shadow.soft, path: 'shadow.soft' },
    { cssName: '--mira-shadow-floating', wxssName: '--mira-shadow-floating', value: designTokens.shadow.floating, path: 'shadow.floating' },
    { cssName: '--mira-shadow-button', wxssName: '--mira-shadow-button', value: designTokens.shadow.button, path: 'shadow.button' },
    { cssName: '--mira-bottom-tabs-height', wxssName: '--mira-bottom-tabs-height', value: designTokens.layout.bottomNavHeight, unit: 'px', path: 'layout.bottomNavHeight' },
    { cssName: '--mira-ask-bar-height', wxssName: '--mira-ask-bar-height', value: designTokens.layout.askBarHeight, unit: 'px', path: 'layout.askBarHeight' },
];
export function tokenValue(variable) {
    return typeof variable.value === 'number' && variable.unit ? `${variable.value}${variable.unit}` : `${variable.value}`;
}
